export default __webpack_public_path__ + "static/media/logo-full-side.c6240d3a.png";